var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip-content"},[_c('p',{staticClass:"explain1"},[_vm._v("经纪商持股比例=经纪商持仓股数/已发行股数")]),_c('p',{staticClass:"explain2"},[_vm._v("持股比例最高的几个经纪商，其持股比例的变化，一定程度能反映机构投资者对后市股价的态度。")])])
}]

export { render, staticRenderFns }